import React, { useState } from 'react';
import { masqueradeService } from '../services/masqueradeService';

interface MasqueradeIndicatorProps {
  masqueradeData: {
    is_masquerading: boolean;
    original_user?: {
      id: number;
      name: string;
      email: string;
    };
    masquerade_started_at?: string;
    duration?: string;
  };
  onStopMasquerade?: () => void;
}

const MasqueradeIndicator: React.FC<MasqueradeIndicatorProps> = ({
  masqueradeData,
  onStopMasquerade
}) => {
  const [loading, setLoading] = useState(false);

  if (!masqueradeData?.is_masquerading) {
    return null;
  }

  const handleStopMasquerade = async () => {
    if (!window.confirm('Are you sure you want to stop masquerading and return to your original account?')) {
      return;
    }

    try {
      setLoading(true);
      const response = await masqueradeService.stopMasquerade();
      
      if (response.success && response.data?.token) {
        // Update the token in localStorage
        localStorage.setItem('token', response.data.token);
        
        // Call the callback if provided
        if (onStopMasquerade) {
          onStopMasquerade();
        } else {
          // Reload the page to refresh the authentication context
          window.location.reload();
        }
      }
    } catch (error: any) {
      console.error('Failed to stop masquerade:', error);
      alert(error.response?.data?.message || 'Failed to stop masquerade');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 mb-4">
      <div className="flex items-center justify-between">
        <div className="flex items-center">
          <div className="flex-shrink-0">
          </div>
          <div className="ml-3">
            <p className="text-sm text-yellow-700">
              <span className="font-medium">Masquerading Mode:</span>{' '}
              You are currently acting as another user.{' '}
              {masqueradeData.original_user && (
                <>
                  Original user: <strong>{masqueradeData.original_user.name}</strong>{' '}
                  ({masqueradeData.original_user.email})
                </>
              )}
              {masqueradeData.duration && (
                <>
                  {' '} • Session duration: <strong>{masqueradeData.duration}</strong>
                </>
              )}
            </p>
          </div>
        </div>
        <div className="flex-shrink-0">
          <button
            onClick={handleStopMasquerade}
            disabled={loading}
            className="inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md text-yellow-700 bg-yellow-100 hover:bg-yellow-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-500 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {loading ? (
              <>
                <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-yellow-700 mr-2"></div>
                Switching back...
              </>
            ) : (
              <>
                <svg
                  className="-ml-0.5 mr-2 h-4 w-4"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M7.707 14.707a1 1 0 01-1.414 0L2.586 11l3.707-3.707a1 1 0 011.414 1.414L6.414 10H17a1 1 0 110 2H6.414l1.293 1.293a1 1 0 010 1.414z"
                    clipRule="evenodd"
                  />
                </svg>
                Switch Back
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default MasqueradeIndicator;





